<p-input-text :placeholder="name" v-model="model" type="text"></p-input-text>